// The message the server wrote for the person using the page, or null. Only a 400 carries one
// (UserMessageException); a 500's message is ErrorHandlerMiddleware's literal "Server error".
export function userMessageOf(error) {
  return (error?.response?.status === 400 && error.response.data?.message) || null;
}

// A 422 is the server refusing what was sent; anything else means the request itself failed.
export function isRefusedInput(error) {
  return error?.response?.status === 422;
}

// What to show when a request failed: the server's own text if it wrote one, else whether it answered at all.
export function requestFailureMessage(error, t) {
  if (!error?.response) return t('auth.noResponse');
  return userMessageOf(error) ?? t('messages.requestFailed');
}
